export const base64Decode = <T>(input: string): T => {

    const decoded = atob(input
        .replace(/-/g, "+")
        .replace(/_/g, "/")
    )

    const unicodeConverted = Array.prototype.map.call(decoded,
        c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    ).join("")

    return JSON.parse(decodeURIComponent(unicodeConverted))
}
